import React from 'react';
import * as misConstantes from '../../js/constantes';
//import './css/estilos.css';
//import './css/main.css';
//import './css/style.css';
//import './css/app.css';
//import './css/bootstrap/bootstrap.css';
//import './css/menu.css';
import logodnp from '../../img/cce-color.png';
import logoFooter from '../../img/LogoGovCo.png';
//
import youTubeFooter from '../../img/youtubeFooter.png';
import twitterFooter from '../../img/twitterFooter.png';
import facebookFooter from '../../img/facebookFooter.png';
import linkedinFooter from '../../img/linkedinFooter.png';
import RSSFooter from '../../img/RSSFooter.png';
import Select from 'react-select';

import Button from 'react-bootstrap/Button';

import axios from "axios";
import VersionApp from "../template/VersionApp";
//import Menu from './pages/template/Menu.js' ;

//function TemplateInicio(  ) {
	
	
class Autenticar extends React.Component {
	
	
	constructor(props) {
    	super(props);
		this.state = {
			mensaje: "",
	     	nitProveedor: "",
			idProveedor: -1,
			usuarios: [],
			usuarioAutenticar: {},
			mostrarResultadoUsuarios:"none", 
			mensajeBuscarUsuarios:"", mostrarBotonBuscarEntidad:"initial", disableNIT: "", 
			mostrarResultadoProveedores: "none", mostrarBotonBuscarProveedorUsuarios: "none",
			proveedores:[], vproveedor:-1, modificarProveedor:true
	    }
  	}
	
	
	
	
	
	

	render(){
		 return (
		<div>
		    <div class="content" style={{display: 'fixed', width: '100%', top: '0px'}} id = 'cabezoteAzulLogosBlanco'>
				<div class="fondo-azul-sin-texto"></div>
				<div class="fondo-azul" style = {{marginBottom: '20px'}}>
					<div class="container" >
						<nav class="navbar navbar-expand-lg navbar-light" style = {{paddingLeft: "0px"}}>
							<div class="logoGov">
								<a href="https://www.gov.co/" target="_blank"><img alt="Logo colombia compra"  style={{ maxWidth: '150px' }} class="img-fluid logovco" src="https://1a1.click/img/Logo%20govco.png" /></a>
							</div>
							<ul class="navbar-nav ml-auto">
								<li class="nav-item active" style={{paddingTop: '2px'}}>
								</li>
							</ul>
						</nav>	
						
					</div>
					<div class="container">
						<div class="fila">
							<div class="col-6 col-md-3 mr-auto" style={{paddingLeft: '10px !important' }}>
								
							</div>
							<div class="col-6 col-md-3 ml-auto" style={{paddingLeft: '10px !important' }}>
								<a href="https://www.dnp.gov.co/"><img class="float-right" id="logodnp" src={logodnp} style={{maxWidth:'125px', width: '100%'}}/></a>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			
			
			
			
			{/*	https://oportunidades.colombiacompra.gov.co/app/ServletTextosSinAutenticar  https://dynaco.co/simulador/test  http://localhost:8080/Simulador/ */}
			
			<div class="container" style={{minHeight: '550px', paddingTop: "120px"}}>
			
			
				<div class="fila">
					<div class="col-lg-3 col-md-3 col-sm-12 mr-auto" style={{paddingLeft: "10px !important" }} ></div>
					<div class="col-lg-6 col-md-6 col-sm-12 mr-auto" style={{paddingLeft: "10px !important"}} >
						<div style={{width: "100%", backgroundColor:  "#42b6e7", padding: "10px", color: "white", textAlign: "center" }}>
							Autenticaci&oacute;n
						</div>
						<div style={{width: "100%", backgroundColor:  "#466ea6", padding: "10px", color: "white", textAlign: "center" }}>
							Bienvenido al sistema de proveedores de simuladores
						</div>
							{/**<form id = 'formularioAutenticar' onSubmit={this.autenticar.bind(this)}>  */}
								<br/>
								<br/>
								NIT Proveedor<br/>
								<input type = 'text' class = 'form-control'  value = {this.state.nitProveedor} placeholder="Escribe el nit sin '.' y sin digiro de verificación, ej 900514913"  onChange = { this.modificoNITProveedor.bind(this) }  /><br/>
								<div style={{ width: "100%", textAlign:  "center", display: this.state.mostrarBotonBuscarProveedor }}>
									<br/>
									<button class = 'btn btn-primary' onClick = { this.buscarProveedores.bind( this ) } style = { { width: "230px" } }>Buscar proveedores</button>
									<br/><br/>
									<br/>{ this.state.mensajeBuscarEntidades }
								</div>
								<div style = {{ display: this.state.mostrarResultadoProveedores, width: "100%" }}>
									Proveedor<br/>
								 	<Select options={ this.state.proveedores }  onChange={ this.seleccionarProveedor.bind( this ) }  setValue = { this.state.idProveedor }  value = { this.state.vproveedor }/>
									<div style={{ width: "100%", textAlign:  "center", display: this.state.mostrarBotonBuscarProveedorUsuarios }}>
										<br/>
										<button class = 'btn btn-primary' onClick={this.volverBuscarProveedor.bind(this)} style = { { width: "230px" } }>Buscar proveedor</button>&nbsp;&nbsp;
										<button class = 'btn btn-primary' onClick={this.buscarUsuarios.bind(this)} style = { { width: "230px" } }>Buscar usuarios</button>
										<br/>{ this.state.mensajeBuscarUsuarios }
									</div>
								</div>	
								<div style = {{ display: this.state.mostrarResultadoUsuarios }}>
									<br/>
									Usuarios
									<Select options={this.state.usuarios} onChange = { this.seleccionarUsuario.bind(this) } />
									
									<div style={{height: "20px"}}>&nbsp;</div>
	
									<div style={{ width: "100%", textAlign:  "center"}}>
										<button class = 'btn btn-primary' onClick={this.volverSeleccionarProveedor.bind(this)} style = { { width: "230px" } }>Seleccionar proveedor</button>&nbsp;&nbsp;
										<button class = 'btn btn-primary' onClick={this.enviarCorreoAutenticacion.bind(this)} style = { { width: "230px" } }>Solicitar correo autenticación</button>
										<br/><br/>
										
									</div>
								</div>
								<div style={{ width: "100%", textAlign:  "center"}}>
									<span id = 'rtaAutenticar'>{this.state.mensaje}</span>
								</div>
								
						{/**	</form>  */}
								<br/><br/><br/><br/><br/>
						
						
					</div>
					<div class="col-lg-3 col-md-3 col-sm-12 mr-auto" style={{paddingLeft: "10px !important" }} ></div>
			
			</div>
			
			
			
			
			
			
			</div>
			<div style={{backgroundColor: "#0164c1"}}>
				<div class="container foot pt-4">
					<div class="fila">
						<div class="col-12 col-md-2 bd">
							<img class="img-fluid" src={logoFooter}/>
						</div>
						
						
						
						
						<div class="col-12 col-md-6 py-4 bd">
							<h5 class="blanco ">Colombia Compra Eficiente</h5>
							
							
							<p class="blanco small">
								Carrera 7 No 26 - 20 Piso 23 / Dirección General / Edificio
								Seguros Tequendama (Bogotá D.C)<br/>
								Código Postal: 110311<br/>
								Horario de atención: de 8:30 a.m a 430 p.m / Lunes a Viernes
							</p>
							
							
							
							<p>
								<a class="blanco" href="/sitemap">Mapa del sitio</a>
							</p>
							<div class="fila">
								<div class="col-md-1 col-2">
									<a href="https://www.facebook.com/ColombiaCompraEficiente/" target="_blank"><img alt="facebook" src={facebookFooter}/></a>
								</div>
								<div class="col-md-1 col-2">
									<a href="https://twitter.com/colombiacompra" target="_blank"><img alt="twitter" src={twitterFooter}/></a>
								</div>
								<div class="col-md-1 col-2">
									<a href="https://www.linkedin.com/company/colombia-compra-eficiente/" target="_blank"><img alt="linkedin" src={linkedinFooter}/></a>
								</div>
								<div class="col-md-1 col-2">
									<a href="https://www.youtube.com/channel/UC2pHOdAhZovC5vE7IsuiGbg" target="_blank"><img alt="youtube" src={youTubeFooter}/></a>
								</div>
								<div class="col-md-1 col-2">
									<a href="/node/22/" target="_blank"><img alt="rss" src={RSSFooter}/></a>
								</div>
							</div>
						</div>
						<div class="col-12 col-md-4 py-4">
							<h6 class="blanco">Contacto de notificaciones judiciales</h6>
							<p class="blanco small" style={{color: "white"}}>
								<a target="_blank" class="blanco" href="mailto:notificacionesjudiciales@colombiacompra.gov.co">notificacionesjudiciales@colombiacompra.gov.co</a><br/>
								Nit. 900514913-2<br/> Linea nacional gratuita: 018000520808<br/>
								PBX: (+57) (1) 7956600<br/> Línea en Bogotá: (+57) (1) 7456788
							</p>
						</div>
					</div>
					<div class="col-12">
						<hr/>
						<div class="d-flex flex-wrap justify-content-between">
							<p class="text-left blanco">&copy; {new Date().getFullYear()}. Colombia Compra Eficiente Todos los derechos reservados</p>
							<VersionApp />
						</div>
					</div>
				</div>
			</div>
		
		</div>
		
	  )
	}
	
	// ----------------------------------------------------
	// Paso 1: Buscar proveedores
	// ----------------------------------------------------
	buscarProveedores() {
		var nit = this.state.nitProveedor;
		var info = {"nit": nit}
		this.setState({mensaje:"Buscando proveedores", entidades:[], mostrarResultadoEntidades: "initial", mostrarBotonBuscarEntidadUsuarios: "initial", mostrarBotonBuscarEntidad: "none" });
		axios.post(misConstantes.URL_CONSULTA +  '/ServletProveedoresAutenticacion', info, {params: info}).then(function (response) {
			var proveedores = response.data;
			
			var proveedoresDef = [];
			for( var i = 0; i < proveedores.length;i++){
				var identificador = proveedores[i].id;
				var correo = proveedores[i].nombre;
				var data = { value:  {value: identificador, label: correo}, label: correo};;
				proveedoresDef.push(data);
			}
			this.setState( { proveedores: proveedoresDef, mensajeBuscarPorveedores: "", mostrarResultadoProveedores:"initial", mostrarBotonBuscarProveedorUsuarios:"initial", mostrarBotonBuscarProveedor: "none", mensaje:"", modificarNIT: false } );
		}.bind(this)).catch(function (error) {
		});
	}
	volverBuscarProveedor(){
		this.setState({mostrarResultadoProveedores: "none", mostrarBotonBuscarProveedor: "initial",  mostrarBotonBuscarProveedorUsuarios: "none", mensaje: "", mensaje:"", modificarNIT: true});
	}
	// ----------------------------------------------------
	// Paso 2: Buscar proveedores
	// ----------------------------------------------------
	seleccionarProveedor( event ){
		var modificarProveedor = this.state.modificarProveedor;
		if( modificarProveedor == true ){
			var vproveedor = event.value;
			this.setState( { vproveedor: vproveedor } );
		}
	}
	// ----------------------------------------------------
	// Paso 3: Buscar proveedores
	// ----------------------------------------------------
	buscarUsuarios(){
		var idProveedor = this.state.vproveedor.value;
		var info = {"idProveedor": idProveedor}
		this.setState({mensaje:"Buscando usuarios", mostrarBotonBuscarProveedorUsuarios:"none", mostrarResultadoUsuarios: "initial", modificarProveedor: false , usuarios: []});
		axios.post(misConstantes.URL_CONSULTA +  '/ServletUsuariosProveedorAutenticacion', info, {params: info}).then(function (response) {
			var usuarios = response.data;
			var usuariosDef = [];
			for( var i = 0; i < usuarios.length;i++){
				const identificador = usuarios[i].id;
				const correo = usuarios[i].correo;
				var data = { value:  {value: identificador, label: correo}, label: correo};;
				usuariosDef.push(data);
			}
			this.setState( { usuarios: usuariosDef, mensajeBuscarEntidades: "", mostrarBotonBuscarEntidad: "initial", mostrarBotonBuscarEntidad: "none", mensaje:"" } );
		}.bind(this)).catch(function (error) {
		});
	}
	seleccionarUsuario(event){
		var idUsuario = event.value.value;
		this.setState( { idUsuario: idUsuario } );
	}
	volverSeleccionarProveedor(){
		this.setState({mostrarBotonBuscarProveedorUsuarios:"initial", mostrarResultadoUsuarios: "none", modificarProveedor: true , usuarios: []});
	}
	enviarCorreoAutenticacion(event) {
		event.preventDefault();
		var idProveedor = this.state.vproveedor.value;
		var idUsuario = this.state.idUsuario;
		
		var info = {"idProveedor":idProveedor	,"idUsuario":idUsuario}
		
		
		this.setState({mensaje:"Enviando correo"});
		axios.post(misConstantes.URL_CONSULTA +  '/ServletEnviarCorreoAutenticacion', info, {params: info}).then(function (response) {
			var respuesta = response.data;
			this.setState( { mensaje: respuesta.mensaje } );
		}.bind(this)).catch(function (error) {

		});
		
		

	}
	// ----------------------------------------------------
	// 
	// ----------------------------------------------------
	modificoNITProveedor(event){
		var nitProveedor = event.target.value;
		if( this.state.idProveedor + "" == "-1" ){
			this.setState({ nitProveedor: nitProveedor });
		}
		
	}
	modificarUsuarioAutenticar(event){
		var usuarioAutenticar = event.value;
		this.setState({usuarioAutenticar:usuarioAutenticar});
	}
	inicioBuscarProveedor(event){
		event.preventDefault();
		this.setState({ idProveedor: "-1", usuarios:[], mensaje:"", mostrarBotonBuscarEntidad:"initial", mostrarResultadoUsuarios:"none"});
	}
}

export default Autenticar;